import { TrackingReportsActionTypes } from './constants';

type TrackingReportsAction = { type: string, payload: {} | string };

export const trackingReportsApiResponseSuccess = (actionType: string, data: any): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const trackingReportsApiResponseError = (actionType: string, error: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const trackingReportsGetDelayedFacilities = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST,
    payload: { query },
});

export const trackingReportsGetDelayedFacilitiesReport = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST,
    payload: { query },
});

export const trackingReportsGetShipmentTrackingRecords = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST,
    payload: { query },
});

export const trackingReportsGetShipmentTrackingReport = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST,
    payload: { query },
});

export const trackingReportsGetAggregatedDelayedShipments = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST,
    payload: { query },
});

export const trackingReportsGetAggregatedDelayedShipmentsReport = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST,
    payload: { query },
});

export const trackingReportsGetAddressReport = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST,
    payload: { query },
});

export const trackingReportsGetAddressReportFile = (query: string): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST,
    payload: { query },
});

export const trackingReportsResetState = (): TrackingReportsAction => ({
    type: TrackingReportsActionTypes.RESET_STATE,
    payload: {},
});
